export default function() {
  return function(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : '';
  };
}



// WEBPACK FOOTER //
// ./client/app/common/filters/capitalizeFirst.js